export default "__VITE_ASSET__DQ9yPB49__"